!function (e, r) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = r(require("react"), require("prop-types"), require("@leafygreen-ui/emotion")) : "function" == typeof define && define.amd ? define(["react", "prop-types", "@leafygreen-ui/emotion"], r) : ((e = "undefined" != typeof globalThis ? globalThis : e || self).Warning = e.Warning || {}, e.Warning.js = r(e.React, e.PropTypes, e["@leafygreen-ui/emotion"]));
}(this, function (e, r, t) {
  "use strict";

  function n(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }
  function i(e) {
    if (e && "object" == typeof e && "default" in e) return e;
    var r = Object.create(null);
    return e && Object.keys(e).forEach(function (t) {
      if ("default" !== t) {
        var n = Object.getOwnPropertyDescriptor(e, t);
        Object.defineProperty(r, t, n.get ? n : {
          enumerable: !0,
          get: function () {
            return e[t];
          }
        });
      }
    }), r.default = e, Object.freeze(r);
  }
  var l = i(e),
    a = n(r);
  function o(e, r, t) {
    return (r = function (e) {
      var r = function (e, r) {
        if ("object" != typeof e || null === e) return e;
        var t = e[Symbol.toPrimitive];
        if (void 0 !== t) {
          var n = t.call(e, r || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === r ? String : Number)(e);
      }(e, "string");
      return "symbol" == typeof r ? r : String(r);
    }(r)) in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  function u() {
    return u = Object.assign ? Object.assign.bind() : function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];
        for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }
      return e;
    }, u.apply(this, arguments);
  }
  function f(e, r) {
    if (null == e) return {};
    var t,
      n,
      i = function (e, r) {
        if (null == e) return {};
        var t,
          n,
          i = {},
          l = Object.keys(e);
        for (n = 0; n < l.length; n++) t = l[n], r.indexOf(t) >= 0 || (i[t] = e[t]);
        return i;
      }(e, r);
    if (Object.getOwnPropertySymbols) {
      var l = Object.getOwnPropertySymbols(e);
      for (n = 0; n < l.length; n++) t = l[n], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (i[t] = e[t]);
    }
    return i;
  }
  function c(e, r) {
    return r || (r = e.slice(0)), Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(r)
      }
    }));
  }
  var s,
    b,
    p = {
      small: 14,
      default: 16,
      large: 20,
      xlarge: 24
    };
  var d = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"],
    y = function (e) {
      var r,
        n = e.className,
        i = e.size,
        a = void 0 === i ? 16 : i,
        y = e.title,
        g = e["aria-label"],
        m = e["aria-labelledby"],
        v = e.fill,
        O = e.role,
        j = void 0 === O ? "img" : O,
        h = f(e, d),
        C = t.css(s || (s = c(["\n        color: ", ";\n      "])), v),
        w = t.css(b || (b = c(["\n        flex-shrink: 0;\n      "]))),
        P = function (e, r, t) {
          var n,
            i,
            l = t["aria-label"],
            a = t["aria-labelledby"],
            u = t.title;
          switch (e) {
            case "img":
              return l || a || u ? (o(n = {}, "aria-labelledby", a), o(n, "aria-label", l), o(n, "title", u), n) : {
                "aria-label": (i = r, "".concat(i.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon"))
              };
            case "presentation":
              return {
                "aria-hidden": !0,
                alt: ""
              };
          }
        }(j, "Warning", (o(r = {
          title: y
        }, "aria-label", g), o(r, "aria-labelledby", m), r));
      return l.createElement("svg", u({
        className: t.cx(o({}, C, null != v), w, n),
        height: "number" == typeof a ? a : p[a],
        width: "number" == typeof a ? a : p[a],
        role: j
      }, P, h, {
        viewBox: "0 0 16 16"
      }), l.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.8639 1.51357C8.49039 0.828811 7.50961 0.828811 7.1361 1.51357L1.12218 12.5388C0.763263 13.1968 1.23814 14 1.98608 14H14.0139C14.7619 14 15.2367 13.1968 14.8778 12.5388L8.8639 1.51357ZM7 5C7 4.44772 7.44772 4 8 4C8.55228 4 9 4.44772 9 5V9C9 9.55228 8.55228 10 8 10C7.44772 10 7 9.55228 7 9V5ZM9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12Z",
        fill: "currentColor"
      }));
    };
  return y.displayName = "Warning", y.isGlyph = !0, y.propTypes = {
    fill: a.default.string,
    size: a.default.oneOfType([a.default.number, a.default.string]),
    className: a.default.string
  }, y;
});